import React from "react";
import { Button, message } from "antd";
import less from "./otp.module.scss";

class Otpinput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      disable: true,
      timer: 30
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.tick = setInterval(this.onTick, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.tick);
  }

  onTick = () => {
    if (this.state.timer === 0) {
      clearInterval(this.tick);
    } else {
      this.setState(prevState => ({
        timer: prevState.timer - 1
      }));
    }
  };

  handleChange(value1, event) {
    this.setState({ [value1]: event.target.value });
  }

  handleSubmit(event) {
    // const data = new FormData(event.target);
    event.preventDefault();
  }

  verifyOTP = async () => {
    const { emailId, number, totalOtp } = this.props;

    let CalOtp =
      this.state.otp1 + this.state.otp2 + this.state.otp3 + this.state.otp4;
    if (totalOtp === 6) {
      CalOtp = CalOtp + this.state.otp5 + this.state.otp6;
    }
    if (this.state.otp == "") {
      message.error("Please enter OTP");
      return;
    }
    if (this.state.otp) {
      CalOtp = this.state.otp;
    }
    const data = {
      mobileNo: number,
      otp: CalOtp,
      emailId
    };
    this.props.verifyOTP(data);
  };

  resendOTP = () => {
    this.setState({ timer: 30 });
    this.tick = setInterval(this.onTick, 1000);
    this.props.resendOtp();
  };

  showNumberInput = () => {
    this.props.hideOtp();
  };

  render() {
    const { timer, otp = "" } = this.state;
    const { showOtpError, userDetails, totalOtp } = this.props;
    const attemptsRemaining = userDetails.noOfWrongAttempt
      ? 3 - userDetails.noOfWrongAttempt
      : 3;

    return (
      <form onSubmit={this.handleSubmit}>
        <div>
          <input
            name="otp"
            type="text"
            inputMode="numeric"
            autoComplete="off"
            className={less.otpInputDesktop}
            pattern="\d*"
            value={otp}
            onChange={e =>
              e.target.validity.valid ? this.handleChange("otp", e) : null
            }
            tabIndex="1"
            maxLength={totalOtp}
          />
        </div>
        {showOtpError ? (
          <>
            <p className={less.wrongOtp}>WRONG OTP ENTERED</p>
          </>
        ) : (
          <>
            {attemptsRemaining > 0 ? (
              <div>
                <span className={less.resendOtp}> Didn’t receive OTP?</span>
                {this.state.timer === 0 ? (
                  <span onClick={this.resendOTP} className={less.resendButton}>
                    Resend OTP
                  </span>
                ) : (
                  <span className={less.resendOtp}>
                    {" "}
                    Resend in 00:
                    {timer}
                  </span>
                )}
              </div>
            ) : null}
          </>
        )}
        <span className={less.editInfo} onClick={this.showNumberInput}>
          Edit {this.props.isEmail ? "Email" : "Number"}{" "}
        </span>

        <Button
          onClick={this.verifyOTP}
          className={less.submitButton}
          type="submit"
          disabled={otp.length !== totalOtp || attemptsRemaining === 0}
        >
          {attemptsRemaining === 0
            ? "Sorry you're Blocked"
            : showOtpError
            ? "Retry"
            : "Confirm"}
        </Button>
      </form>
    );
  }
}

export default Otpinput;
